import React from "react";
import { useNavigate } from "react-router-dom";
import { MdBlock, MdDashboard, MdArrowBack } from "react-icons/md";

export default function SuspendedPage({ moduleName = "This Page" }) {
  const navigate = useNavigate();

  return (
    <div className="suspended-page-container">
      <style>{`
        .suspended-page-container {
          min-height: calc(100vh - 120px);
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
        }

        .suspended-card {
          background: #ffffff;
          border-radius: 20px;
          border: 1px solid #fee2e2;
          box-shadow: 0 10px 30px rgba(225, 29, 72, 0.06), 0 4px 12px rgba(15, 23, 42, 0.03);
          max-width: 540px;
          width: 100%;
          padding: 44px 36px;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;
          position: relative;
          overflow: hidden;
        }

        .suspended-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 5px;
          background: linear-gradient(90deg, #e11d48, #f59e0b);
        }

        .suspended-icon-wrapper {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: #fff1f2;
          color: #e11d48;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2.5rem;
          margin-bottom: 22px;
          box-shadow: 0 6px 18px rgba(225, 29, 72, 0.15);
        }

        .suspended-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: #fef2f2;
          color: #b91c1c;
          font-size: 0.76rem;
          font-weight: 700;
          padding: 5px 14px;
          border-radius: 9999px;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          margin-bottom: 14px;
          border: 1px solid #fecaca;
        }

        .suspended-badge-dot {
          width: 7px;
          height: 7px;
          border-radius: 50%;
          background: #e11d48;
        }

        .suspended-title {
          font-size: 1.5rem;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 12px;
          letter-spacing: -0.02em;
        }

        .suspended-desc {
          font-size: 0.95rem;
          color: #64748b;
          line-height: 1.6;
          margin-bottom: 30px;
        }

        .suspended-notice-box {
          background: #f8fafc;
          border-radius: 12px;
          padding: 14px 18px;
          margin-bottom: 28px;
          border: 1px dashed #cbd5e1;
          width: 100%;
          font-size: 0.85rem;
          color: #475569;
        }

        .suspended-notice-box strong {
          color: #0f172a;
        }

        .suspended-actions {
          display: flex;
          gap: 12px;
          flex-wrap: wrap;
          justify-content: center;
          width: 100%;
        }

        .btn-dash {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: linear-gradient(135deg, #0067B1 0%, #1e40af 100%);
          color: #ffffff;
          padding: 11px 22px;
          border-radius: 10px;
          font-size: 0.9rem;
          font-weight: 600;
          border: none;
          cursor: pointer;
          transition: all 0.2s ease;
          box-shadow: 0 4px 12px rgba(0, 103, 177, 0.2);
        }

        .btn-dash:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 18px rgba(0, 103, 177, 0.3);
        }

        .btn-back {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          background: #f1f5f9;
          color: #334155;
          padding: 11px 20px;
          border-radius: 10px;
          font-size: 0.9rem;
          font-weight: 600;
          border: 1px solid #e2e8f0;
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .btn-back:hover {
          background: #e2e8f0;
          color: #0f172a;
        }
      `}</style>

      <div className="suspended-card">
        <div className="suspended-icon-wrapper">
          <MdBlock />
        </div>

        <div className="suspended-badge">
          <span className="suspended-badge-dot"></span>
          Access Suspended
        </div>

        <h2 className="suspended-title">{moduleName} Suspended</h2>

        <p className="suspended-desc">
          This module is currently suspended and has been disabled by the system administrator.
          Direct link and URL access to this section is not permitted.
        </p>

        <div className="suspended-notice-box">
          Access denied for <strong>{moduleName}</strong>. If you believe this is an error, please contact your Super Admin.
        </div>

        <div className="suspended-actions">
          <button className="btn-dash" onClick={() => navigate("/admin/dashboard")}>
            <MdDashboard style={{ fontSize: "1.1rem" }} />
            Back to Dashboard
          </button>
          <button className="btn-back" onClick={() => navigate(-1)}>
            <MdArrowBack style={{ fontSize: "1.1rem" }} />
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
}
